<form [formGroup]="siddhaYogaParticipationForm">
  <div class="step-container">
    <ng-template #labelSix>{{ getTranslation('studyParticipation.title') }}</ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('studyParticipation.title') : getTranslation('studyParticipation.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>


    <div *ngIf="isJsonShow">
      {{siddhaYogaParticipationForm.value |json}}
    </div>
   





    <div class="row gx-2">


      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['BeginPracticeYear'].invalid && submitted}">
            {{ getTranslation('studyParticipation.beginPracticeYear') }} <span class="text-danger">*</span>
          </label>
          <div class="col-md-4 d-flex flex-column">
            <app-custome-year-picker [formControl]="getPracticeYearControl()"
              [placeholder]="getTranslation('studyParticipation.selectPracticeYear')"
              [maxYear]="currentYear"></app-custome-year-picker>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['BeginPracticeYear'].invalid"
              class="text-danger">
              {{ getTranslation('validation.beginPracticeYearRequired') }}
            </div>
          </div>
        </div>
      </div>



      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['PracticeBeginDetails'].invalid && submitted}">
            {{ getTranslation('studyParticipation.whereBeginPractice') }} <span class="text-danger">*</span>
          </label>
          <div class="col-md-4 d-flex flex-column">
            <select class="form-control" formControlName="PracticeBeginDetails">
              <option value="">{{ getTranslation('studyParticipation.selectOption') }}</option>
              <option value="siddha-yoga-centre">{{ getTranslation('studyParticipation.siddhaYogaCentre') }}</option>
              <option value="home">{{ getTranslation('studyParticipation.home') }}</option>
              <option value="other">{{ getTranslation('studyParticipation.other') }}</option>
            </select>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['PracticeBeginDetails'].invalid"
              class="text-danger">
              {{ getTranslation('validation.practiceBeginDetailsRequired') }}
            </div>
          </div>
        </div>
      </div>



      <!-- Text input when user selects 'other' -->
      <div class="form-group col-12 mb-3" *ngIf="isOtherCurrentCenterDetailsRequired()">
        <div class="row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.ifOtherMention') }} <span
              class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <input type="text" class="form-control" formControlName="OtherCurrentCenterDetails"
              [placeholder]="getTranslation('studyParticipation.enterCentreName')" maxlength="100"
              [class.is-invalid]="isOtherCurrentCenterDetailsInvalid()">
          </div>
        </div>
        <!-- Validation message -->
        <div class="row" *ngIf="isOtherCurrentCenterDetailsInvalid()">
          <div class="col-md-8"></div>
          <div class="col-md-4">
            <div class="invalid-feedback d-block"
              *ngIf="siddhaYogaParticipationForm.get('OtherCurrentCenterDetails')?.errors?.['required']">
              {{ getTranslation('validation.otherCentreRequired') }}
            </div>
          </div>
        </div>
      </div>

      <!-- Dropdown when user selects 'siddha-yoga-centre' -->
      <div class="form-group col-12 mb-3" *ngIf="isOtherCurrentCenterDropdownRequired()">
        <div class="row">
          <label class="form-label col-md-8 mb-0">
            {{ getTranslation('studyParticipation.whichCentreVisit') }} <span class="text-danger">*</span>
          </label>
          <div class="col-md-4 d-flex flex-column">
            <ng-select [items]="otherCurrentCenterList" [searchable]="true" formControlName="OtherCurrentCenterDetails"
              bindLabel="name" bindValue="value" [compareWith]="compareCenters" class="custom-ng-select"
              [placeholder]="getTranslation('studyParticipation.enterCentrePlaceholder')"
              (search)="onOtherCurrentCenterSearchInput($event)" (clear)="onOtherCurrentCenterClear()" 
              [closeOnSelect]="true" [minTermLength]="3" [clearable]="true">
            </ng-select>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['OtherCurrentCenterDetails']?.invalid"
              class="text-danger">
              {{ getTranslation('validation.centreRequired') }}
            </div>
          </div>
        </div>
      </div>
      <!-- End NRE Question Section -->






      <!-- <div class="form-group col-12 mb-3" *ngIf="siddhaYogaParticipationForm.get('IsVisitingSiddhaYogaCentre')?.value === true"> -->
      <div class="form-group col-12 mb-3">
        <div class="row">
          <label for="CenterVisitFrequency" class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['CenterVisitFrequency'].invalid && submitted}">
            {{ getTranslation('studyParticipation.howOftenVisit') }} <span class="text-danger">*</span>
          </label>

          <div class="col-md-4 d-flex flex-column">
            <select class="form-control" id="CenterVisitFrequency" formControlName="CenterVisitFrequency">
              <option value="" disabled>{{ getTranslation('studyParticipation.selectFrequency') }}</option>
              <option value="Weekly">{{ getTranslation('studyParticipation.weekly') }}</option>
              <option value="Monthly">{{ getTranslation('studyParticipation.monthly') }}</option>
              <option value="Occasionally">{{ getTranslation('studyParticipation.occasionally') }}</option>
              <option value="Never">{{ getTranslation('studyParticipation.never') }}</option>
            </select>

            <!-- Validation message exactly below the field -->
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['CenterVisitFrequency'].invalid"
              class="text-danger">
              {{ getTranslation('validation.centerVisitFrequencyRequired') }}
            </div>
          </div>
        </div>
      </div>















      <div class="form-group col-12 mb-3">
        <div class="row">
          <!-- Main question label -->
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['CurrentCenterDetails'].invalid && submitted}">
            {{ getTranslation('studyParticipation.whichCentreVisit') }} <span class="text-danger">*</span>
          </label>

          <!-- Dropdown wrapper -->

       
          <div class="col-md-4 d-flex flex-column">
          <ng-select [items]="currentCenterList" [searchable]="true" formControlName="CurrentCenterDetails"
              bindLabel="name" bindValue="value" [compareWith]="compareCenters" class="custom-ng-select"
              [placeholder]="getTranslation('studyParticipation.enterCentrePlaceholder')"
              (search)="onCurrentCenterSearchInput($event)" (clear)="onCurrentCenterClear()" 
              (open)="onCurrentCenterDropdownOpen()" (change)="onCurrentCenterChange($event)"
              [closeOnSelect]="true" [minTermLength]="3">
            </ng-select>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['CurrentCenterDetails']?.invalid"
              class="text-danger">
              {{ getTranslation('validation.centreRequired') }}
            </div>
          </div>
        </div>
      </div>











































      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['CurrentSYPractices'].invalid && submitted}">
            {{ getTranslation('studyParticipation.whichPracticeEngage') }} <span class="text-danger">*</span>
          </label>
          <div class="col-md-4 d-flex flex-column">
            <ng-select [items]="practiceOptions" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              [placeholder]="getTranslation('studyParticipation.selectPractice')" formControlName="CurrentSYPractices" 
              [closeOnSelect]="false" [hideSelected]="false" [clearable]="false" (change)="onCurrentSYPracticesChange($event)">
              <ng-template ng-option-tmp let-item="item">
                {{ getTranslation(item.translationKey) }}
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                {{ getTranslation(item.translationKey) }}
              </ng-template>
            </ng-select>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['CurrentSYPractices'].invalid"
              class="text-danger">
              {{ getTranslation('validation.currentSYPracticesRequired') }}
            </div>
          </div>
        </div>
      </div>



      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['IsEngagedWithTeachings'].invalid && submitted}">
            {{ getTranslation('studyParticipation.regularlyEngageTeachings') }} <span class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class=" mr-5"><input type="radio" class="form-check-input" formControlName="IsEngagedWithTeachings"
                [value]="true" class="me-2"> {{ getTranslation('studyParticipation.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="IsEngagedWithTeachings" [value]="false"
                class="me-2"> {{ getTranslation('studyParticipation.no') }}</label>
            <br>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['IsEngagedWithTeachings'].invalid"
              class="text-danger-val">
              {{ getTranslation('validation.isEngagedWithTeachingsRequired') }}
            </div>
          </div>
        </div>
      </div>

      <div class="form-group col-12 mb-3"
        *ngIf="siddhaYogaParticipationForm.get('IsEngagedWithTeachings')?.value === true">
        <div class="row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.ifYesSelected') }}</label>
          <div class="col-md-4 d-flex align-items-center">
            <ng-select [items]="teachingOptions" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              [placeholder]="getTranslation('studyParticipation.selectOptions')" formControlName="EngagedTeachingDetails" [closeOnSelect]="false"
              [hideSelected]="false" [clearable]="false" (change)="onEngagedTeachingDetailsChange($event)">
              <ng-template ng-option-tmp let-item="item">
                <input type="checkbox" [checked]="isEngagedTeachingOptionSelected(item.value)"
                  (change)="toggleEngagedTeachingOption(item.value)" class="me-2">
                {{ getTranslation(item.translationKey) }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <!-- Conditional question for Siddha Yoga Path Website frequency -->
      <div class="form-group col-12 mb-3" *ngIf="isSiddhaYogaPathWebsiteSelected()">
        <div class="row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.howOftenVisitWebsite') }}</label>
          <div class="col-md-4 d-flex align-items-center">
            <select class="form-control" formControlName="SiddhaYogaPathWebsiteFrequency">
              <option value="">{{ getTranslation('studyParticipation.selectFrequency') }}</option>
              <option value="Daily">{{ getTranslation('studyParticipation.daily') }}</option>
              <option value="Weekly">{{ getTranslation('studyParticipation.weekly') }}</option>
              <option value="Monthly">{{ getTranslation('studyParticipation.monthly') }}</option>
              <option value="Occasionally">{{ getTranslation('studyParticipation.occasionally') }}</option>
            </select>
          </div>
        </div>
      </div>


      <div class="form-group col-12 mb-3">
        <div class="row">
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['IsParticipateInSadhanaCircle'].invalid && submitted}">
            {{ getTranslation('studyParticipation.participateSadhanaCircle') }} <span class="text-danger">*</span></label>
          <div class="col-md-4 d-flex align-items-center">
            <label class=" mr-5"><input type="radio" class="form-check-input"
                formControlName="IsParticipateInSadhanaCircle" [value]="true" class="me-2"> {{ getTranslation('studyParticipation.yes') }}</label>
            <label><input type="radio" class="form-check-input" formControlName="IsParticipateInSadhanaCircle"
                [value]="false" class="me-2"> {{ getTranslation('studyParticipation.no') }}</label>


            <br>
            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['IsParticipateInSadhanaCircle'].invalid"
              class="text-danger-val">
              {{ getTranslation('validation.isParticipateInSadhanaCircleRequired') }}
            </div>

          </div>
        </div>
      </div>

      <!-- Conditional question for Sadhana Circle frequency -->
      <div class="form-group col-12 mb-3"
        *ngIf="siddhaYogaParticipationForm.get('IsParticipateInSadhanaCircle')?.value === true">
        <div class="row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.howOften') }}</label>
          <div class="col-md-4 d-flex align-items-center">
            <select class="form-control" formControlName="SadhanaCircleParticipationFrequency">
              <option value="">{{ getTranslation('studyParticipation.selectFrequency') }}</option>
              <option value="Weekly">{{ getTranslation('studyParticipation.weekly') }}</option>
              <option value="Monthly">{{ getTranslation('studyParticipation.monthly') }}</option>
              <option value="Occasionally">{{ getTranslation('studyParticipation.occasionally') }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- First Shaktipat Intensive Year -->




      <!-- Event History Section -->
      <div class="form-group col-12 mb-4 event-history-section">
        <h5 class="mb-3">{{ getTranslation('studyParticipation.eventParticipationHistory') }}:</h5>





        
     
        <div class="row mb-3 event-row">
          <label class="form-label col-md-8 mb-0"
            [ngClass]="{'text-danger': siddhaYogaParticipationForm.controls['FirstIntensiveYear'].invalid && submitted}">
            {{ getTranslation('studyParticipation.firstShaktipatIntensive') }} <span class="text-danger">*</span>
          </label>
          <div class="col-md-4 d-flex flex-column">
            <app-custome-year-picker [formControl]="getFirstIntensiveYearControl()"
              [placeholder]="getTranslation('studyParticipation.selectFirstIntensiveYear')"
              [maxYear]="currentYear">
            </app-custome-year-picker>

            <div *ngIf="submitted && siddhaYogaParticipationForm.controls['FirstIntensiveYear'].invalid"
              class="text-danger">
              {{ getTranslation('validation.firstIntensiveYearRequired') }}
            </div>
          </div>
        </div>
  
        <p class="mb-3 text-muted">{{ getTranslation('studyParticipation.eventParticipationHistorySubHeader') }}</p>


        <!-- Shaktipat Intensive -->
        <div class="row mb-3 event-row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.shaktipatIntensive') }}</label>
          <div class="col-md-4 d-flex align-items-center">


            <ng-select [items]="last10YearsWithNone" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              placeholder="Select options" formControlName="IntensiveHistory" [closeOnSelect]="false"
              [hideSelected]="false" [clearable]="false">
              <ng-template ng-option-tmp let-item="item">
                <input type="checkbox" [checked]="isIntensiveHistoryOptionSelected(item.value)"
                  (change)="toggleIntensiveHistoryOption(item.value)" class="me-2">
                {{ item.name }}
              </ng-template>
            </ng-select>

          </div>
        </div>


        
        <!-- Audio Satsangs -->
        <div class="row mb-3 event-row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.audioSatsangs') }}</label>
          <div class="col-md-4 d-flex align-items-center">


            <ng-select [items]="last10YearsWithNone" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              placeholder="Select options" formControlName="AudioSatsangHistory" [closeOnSelect]="false"
              [hideSelected]="false" [clearable]="false">
              <ng-template ng-option-tmp let-item="item">
                <input type="checkbox" [checked]="isAudioSatsangHistoryOptionSelected(item.value)"
                  (change)="toggleAudioSatsangHistoryOption(item.value)" class="me-2">
                {{ item.name }}
              </ng-template>
            </ng-select>



          </div>
        </div>

        <!-- Live Streams -->
        <div class="row mb-3 event-row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.liveStreams') }}</label>
          <div class="col-md-4 d-flex align-items-center">


            <ng-select [items]="last10YearsWithNone" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              placeholder="Select options" formControlName="LiveStreamHistory" [closeOnSelect]="false"
              [hideSelected]="false" [clearable]="false">
              <ng-template ng-option-tmp let-item="item">
                <input type="checkbox" [checked]="isLiveStreamHistoryOptionSelected(item.value)"
                  (change)="toggleLiveStreamHistoryOption(item.value)" class="me-2">
                {{ item.name }}
              </ng-template>
            </ng-select>





          </div>
        </div>

        <!-- Muktananda Dhyan Saptah -->
        <div class="row mb-3 event-row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.muktanandaDhyanSaptah') }}</label>
          <div class="col-md-4 d-flex align-items-center">



            <ng-select [items]="last10YearsWithNone" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              placeholder="Select options" formControlName="MDSHistory" [closeOnSelect]="false" [hideSelected]="false"
              [clearable]="false">
              <ng-template ng-option-tmp let-item="item">
                <input type="checkbox" [checked]="isMDSHistoryOptionSelected(item.value)"
                  (change)="toggleMDSHistoryOption(item.value)" class="me-2">
                {{ item.name }}
              </ng-template>
            </ng-select>



          </div>
        </div>

        <!-- Sweet Surprise Satsang -->
        <div class="row mb-3 event-row">
          <label class="form-label col-md-8 mb-0">{{ getTranslation('studyParticipation.sweetSurpriseSatsang') }}</label>
          <div class="col-md-4 d-flex align-items-center">



            <ng-select [items]="last10YearsWithNone" [multiple]="true" [bindLabel]="'name'" [bindValue]="'value'"
              placeholder="Select options" formControlName="SweetSurpriseHistory" [closeOnSelect]="false"
              [hideSelected]="false" [clearable]="false">
              <ng-template ng-option-tmp let-item="item">
                <input type="checkbox" [checked]="isSweetSurpriseHistoryOptionSelected(item.value)"
                  (change)="toggleSweetSurpriseHistoryOption(item.value)" class="me-2">
                {{ item.name }}
              </ng-template>
            </ng-select>


          </div>
        </div>
      </div>



    </div>

    <!-- Retreat History Section -->
    <div class="form-group col-12 mb-4">
      <h5 class="mb-3">{{ getTranslation('studyParticipation.retreatHistory') }}:</h5>
      <p class="text-muted mb-3 small">Begin with the most recent. E.g. Pilgrimage to the heart retreat</p>
      <div formArrayName="retreatHistory">
        <div *ngFor="let retreatForm of retreatHistoryArray.controls; let i = index" [formGroupName]="i"
          class="retreat-row mb-3 p-3 border rounded" [attr.data-index]="i + 1">
          <div class="row gx-2">
            <!-- Retreat Name -->
            <div class="col-md-6 mb-2">
              <label [for]="'retreatName' + i" class="form-label">
                {{ getTranslation('studyParticipation.retreatName') }} <span class="text-danger">*</span>
              </label>


              <!-- <input type="text" class="form-control" [id]="'retreatName' + i" formControlName="RetreatName" placeholder="Enter Retreat Name" maxlength="100"> -->



              <select class="form-control" [id]="'retreatName' + i" formControlName="RetreatName">
                <option value="" disabled selected>{{ getTranslation('studyParticipation.selectRetreatName') }}</option>
                <option *ngFor="let retreat of retreatOptions" [value]="retreat.OptionValue">{{ retreat.OptionText }}
                </option>
              </select>



              <div *ngIf="submitted && retreatForm.get('RetreatName')?.invalid" class="text-danger">
                {{ getTranslation('validation.retreatNameRequired') }}
              </div>
            </div>

            <!-- Retreat Date -->
            <div class="col-md-4 mb-2">
              <label [for]="'retreatDate' + i" class="form-label">
                {{ getTranslation('studyParticipation.retreatDate') }} <span class="text-danger">*</span>
              </label>
              <app-custom-date-picker formControlName="RetreatDate" [placeholder]="getTranslation('studyParticipation.selectDate')" [maxDate]="today">
              </app-custom-date-picker>
              <div *ngIf="submitted && retreatForm.get('RetreatDate')?.invalid" class="text-danger">
                {{ getTranslation('validation.retreatDateRequired') }}
              </div>
            </div>

            <!-- Delete Button -->
            <div class="col-md-2 mb-2 d-flex align-items-end justify-content-center">
              <button type="button" class="btn btn-link text-danger p-0 delete-btn" (click)="removeRetreatHistoryRow(i)"
                *ngIf="!isPreviewMode" [title]="getTranslation('studyParticipation.deleteRetreat')">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Add New Retreat Button -->
      <div class="row mb-3" *ngIf="!isPreviewMode">
        <div class="col-12">
          <button type="button" class="btn btn-success" (click)="addRetreatHistoryRow()">
            <i class="fas fa-plus"></i> {{ getTranslation('studyParticipation.addNewRetreat') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Seva History Section -->
    <div class="form-group col-12 mb-4">
      <h5 class="mb-3">{{ getTranslation('studyParticipation.sevaHistory') }}</h5>
      <p class="text-muted mb-3 small">Begin with the most recent seva.</p>
      <div formArrayName="sevaHistory">
        <div *ngFor="let sevaForm of sevaHistoryArray.controls; let i = index" [formGroupName]="i"
          class="seva-row mb-3 p-3 border rounded" [attr.data-index]="i + 1">


          <div class="row gy-2 gx-2">
            <div class="col-12 col-md-2">
              <label>{{ getTranslation('studyParticipation.ashramName') }} *</label>
              <select class="form-control" formControlName="AshramName">
                <option value="" disabled selected>{{ getTranslation('studyParticipation.selectAshramName') }}</option>
                <option *ngFor="let ashram of ashramOptions" [value]="ashram.OptionValue">{{ ashram.OptionText }}
                </option>
              </select>

              <!-- <input type="text" class="form-control" formControlName="AshramName" placeholder="Ashram Name"
                maxlength="100"> -->

                
            </div>
            <div class="col-12 col-md-2">
              <label>{{ getTranslation('studyParticipation.sevaRole') }} *</label>
              <input type="text" class="form-control" formControlName="SevaRole" [placeholder]="getTranslation('studyParticipation.sevaRole')" maxlength="50">
            </div>
            <div class="col-12 col-md-2">
              <label>{{ getTranslation('studyParticipation.department') }} *</label>
              <input type="text" class="form-control" formControlName="Department" [placeholder]="getTranslation('studyParticipation.department')"
                maxlength="50">
            </div>
            <div class="col-12 col-md-2">
              <label>{{ getTranslation('studyParticipation.year') }} *</label>

              <app-custome-year-picker formControlName=Year [placeholder]="getTranslation('studyParticipation.year')"
                [maxYear]="currentYear">
              </app-custome-year-picker>


              <!-- <input type="text" class="form-control" formControlName="Year" placeholder="Year"> -->
            </div>
            <div class="col-12 col-md-2">
              <label>{{ getTranslation('studyParticipation.duration') }} *</label>
              <input type="text" class="form-control" formControlName="Duration" [placeholder]="getTranslation('studyParticipation.duration')" maxlength="50">
            </div>
            <div class="col-12 col-md-2">
              <label>{{ getTranslation('studyParticipation.supervisorName') }} *</label>
              <input type="text" class="form-control" formControlName="SupervisorName" [placeholder]="getTranslation('studyParticipation.supervisorName')"
                maxlength="50">
            </div>
            <div class="col-auto d-flex align-items-end">


              <button type="button" class="btn btn-link text-danger p-0 delete-btn" (click)="removeSevaHistoryRow(i)"
                *ngIf="!isPreviewMode" [title]="getTranslation('studyParticipation.deleteSeva')">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                    fill="currentColor" />
                </svg>
              </button>


            </div>
          </div>



        </div>
      </div>

      <!-- Add New Seva Button -->
      <div class="row mt-2" *ngIf="!isPreviewMode">

        <button type="button" class="btn btn-success" (click)="addSevaHistoryRow()">
          <i class="fas fa-plus me-1"></i> {{ getTranslation('studyParticipation.addNewSeva') }}
        </button>

      </div>
    </div>

  </div>


  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" *ngIf="siddhaYogaParticipationForm.get('SaveMode')?.value !== SaveMode.SAVE" (click)="onSubmit(SaveMode.DRAFT)" >
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->


</form>